<template>
  <div class="flex flex-wrap">
    <div class="w-full bg-gray-bg z-50 sticky pin-t md:relative md:w-1/4 pt-2 pb-5">
      <input id="dropdown" type="checkbox">
      <label class="mobile__dropdown md:hidden block bg-black text-white uppercase text-lg px-3 py-3 flex" for="dropdown">
        <span class="flex-1 block">Current Step: {{ pageTitle }}</span>
        <span class="block">
          <svg width="20" height="17" xmlns="http://www.w3.org/2000/svg"><path d="M10 16.667L0 0h20z" fill="#FFF" fill-rule="evenodd"/></svg>
        </span>
      </label>
      <ul class="list-reset nav__sidebar border-b-8 md:border-b-0 md:border-t-8 border-black overflow-hidden md:overflow-visible md:h-auto md:opacity-100">
        <li v-if="user.isAdmin">
          <router-link class="font-sans-bold text-red" :to="`/resources/${resourceId}/admin`">
            Admin Settings
          </router-link>
        </li>
        <li v-for="resourceRoute in resourceRoutes">
          <router-link :to="resourceRoute.to" :class="{'errors': ! resourceRoute.status}">
            {{ resourceRoute.text }}
            <span class="flex flex-1 justify-end" v-if="resourceRoute.status">
              <svg class="active-white" width="28" height="29" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 .557h27.444V28H0z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(0 .318)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0" fill="#000" mask="url(#b)"/></g><path d="M12.35 21.458c-.327 0-.644-.117-.895-.332l-4.803-4.127a1.372 1.372 0 0 1 1.789-2.082l3.627 3.117 6-9.001a1.372 1.372 0 1 1 2.284 1.522l-6.861 10.29a1.366 1.366 0 0 1-1.141.613" fill="#000"/></g></svg>
            </span>
            <span class="flex flex-1 justify-end" v-else>
              <svg class="tab-status-incomplete" width="28" height="29" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 .557h27.444V28H0z"/></defs><g transform="translate(0 .318)" fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0" fill="#9B9B9B" mask="url(#b)"/></g></svg>
            </span>
          </router-link>
        </li>
        <li v-if="user.isAdmin">
          <router-link :to="`/resources/${this.resourceId}/tags`" :class="{'errors': ! resourceTagStatus}">
            Tags
            <span class="flex flex-1 justify-end" v-if="resourceTagStatus">
              <svg class="active-white" width="28" height="29" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 .557h27.444V28H0z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(0 .318)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0" fill="#000" mask="url(#b)"/></g><path d="M12.35 21.458c-.327 0-.644-.117-.895-.332l-4.803-4.127a1.372 1.372 0 0 1 1.789-2.082l3.627 3.117 6-9.001a1.372 1.372 0 1 1 2.284 1.522l-6.861 10.29a1.366 1.366 0 0 1-1.141.613" fill="#000"/></g></svg>
            </span>
            <span class="flex flex-1 justify-end" v-else>
              <svg class="tab-status-incomplete" width="28" height="29" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 .557h27.444V28H0z"/></defs><g transform="translate(0 .318)" fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0" fill="#9B9B9B" mask="url(#b)"/></g></svg>
            </span>
          </router-link>
        </li>
        <li>
          <router-link :to="`/resources/${resourceId}/submit`" class="text-grey-darkest">
            <template v-if="resource.status === 'draft'">
              Submit for Review <span class="flex flex-1 justify-end"><svg class="right active-white" width="17" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M13.16 6.99L7.578 1.412 8.99 0 17 8l-8.01 8-1.413-1.412 5.608-5.601H0V6.99z" fill="#010B19" fill-rule="evenodd"/></svg></span>
            </template>
            <template v-else>
              Status <span class="flex flex-1 justify-end pr-1"><svg class="float-right mt-1 active-white" width="17" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M13.16 6.99L7.578 1.412 8.99 0 17 8l-8.01 8-1.413-1.412 5.608-5.601H0V6.99z" fill="#010B19" fill-rule="evenodd"/></svg></span>
            </template>
          </router-link>
        </li>
        <li v-if="user.isAdmin">
          <admin-queueton-status resource="resource" :resource-id="resourceId" />
        </li>
      </ul>
    </div>
    <div class="w-full md:w-3/4 md:pl-6">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import AdminQueuetonStatus from "../admin/AdminQueuetonStatus.vue";

export default {
  name: 'ResourceCreateModule',
  props: {},
  components:{AdminQueuetonStatus},
  data: () => ({

  }),
  computed: {
    ...mapGetters({
      user: 'user',
      resource: 'resource',
      resourceValidation: 'resourceValidation',
    }),
    resourceId() {
      return this.$route.params.id
    },
    isAdmin() {
      return this.user.isAdmin
    },
    resourceRoutes() {
      return [
        {
          to: `/resources/${this.resourceId}/basics`,
          text: 'Basics',
          status: this.resourceValidation.basics
        },
        {
          to: `/resources/${this.resourceId}/details`,
          text: 'Details',
          status: this.resourceValidation.details
        }
      ]
    },
    resourceTagStatus() {
      return this.resourceValidation.tags
    },
    pageTitle() {
      return this.$route.meta.title
    }
  },
  watch: {
    resource(resource) {
      this.$store.dispatch('setResourceValidation', resource)
    }
  },
  methods: {},
  mounted() {}
}
</script>
